const expenseItemFields = [
  'infoMedicalExpensesItems',
  'infoOpticalTreatmentItems',
  'infoAncillaryServicesItems',
  'infoMentalHealthItems',
  'infoSexualHealthItems',
  'infoExtraTravelAndAccommodationItems',
  'infoSearchAndRescueItems',
  'infoUrgentCareOutOfHoursVisitsItems',
  'infoPrescriptionsItems',
  'infoGPVisitsItems',
  'infoRehabilitationAndOccupationalTherapyItems',
  'infoMaternityCareItems',
  'infoReplacementStaffItems',
  'infoRepatriationBenefitItems',
  'infoOtherMedicalExpensesItems',
  'infoMedicalExpensesHospitalisedItems',
  'infoMedicalExpensesCompanionItems',
  'infoDentalExpensesItems',
  'infoFuneralExpensesItems',
  'infoTheDeathCausedByAnInjuryItems',
  'infoExpensesArisingFromTerrorismItems',
];

const showSubBenefitsPolicies = ['VISIT-NZ', 'VISIT-NZ-WLP001', 'WORK-AU', 'WORK-NZ', 'INT-ST-NZ'];

const toArray = (field) => {
  if (field && typeof field.toJS === 'function') return field.toJS();
  return field;
};

export const hasAnyMedicalAndEvacuationExpenseItems = (form = {}, policyTypeCode) => {
  const whatExpensesAreYouClaimingFor = toArray(form.whatExpensesAreYouClaimingFor) || [];
  const isMedicalHospitalExpensesSelected = Array.isArray(whatExpensesAreYouClaimingFor)
    && whatExpensesAreYouClaimingFor.includes('Medical & Hospital Expenses');

  if (isMedicalHospitalExpensesSelected && showSubBenefitsPolicies.includes(policyTypeCode)) {
    // For sub-benefit policies, require at least one sub-benefit checkbox selected
    const whatAreYourExpensesRelatedTo = toArray(form.whatAreYourExpensesRelatedTo) || [];
    if (!Array.isArray(whatAreYourExpensesRelatedTo) || whatAreYourExpensesRelatedTo.length === 0) {
      return false;
    }
  }

  return expenseItemFields.some((field) => {
    const arr = toArray(form[field]);
    return Array.isArray(arr) && arr.length > 0;
  });
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/validation.js